export default __webpack_public_path__ + "static/media/sort-icon.0218190d.svg";